import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigService } from 'src/app/services/core/config/config.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { sweetAlert } from 'src/app/utils/swal';
import { addressValidator } from 'src/app/utils/custom-validators';
import { allowOnlyNumbersValidator, onTimeChange, phoneNumberLengthValidator, timeZone } from 'src/app/utils/utils.common';
import { validateFileSize } from 'src/app/utils/common.utils';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import * as moment from 'moment';
import { urls } from 'src/app/utils/url.utils';
import { environment } from 'src/environments/environment';
@UntilDestroy()
@Component({
  selector: 'app-global-configuration',
  templateUrl: './global-configuration.component.html',
  styleUrls: ['./global-configuration.component.css']
})
export class GlobalConfigurationComponent implements OnInit {
  userPermission=UserPermission
  globalConfigForm!: FormGroup;
     configId :any;
     submitted = false;
     user: any;
     companyWiseConfiguration: any;
  companyList:any = [];
  selectedFile: ImageSnippet | null = null;
  timezones:any = moment.tz.names();
  imageUrl:any
  selectedTime: any = "00:00"

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private configService: ConfigService,
    private sharedDataService:SharedDataService,
    public permissionService: PermissionService,
    private credentialService: CredentialService,
    private uploadService: UploadService,
  ){

  }

  ngOnInit() {
    this.getUser();
    this.globalConfigForm = this.fb.group({
      primaryCompany: [''],
      quickbooks: this.fb.group({
        username: [''],
        password: [''],
        isAutoInvoice: [false],
        isAutoAccepted: [false],
        isAutoBill: [false]
      }),
      jotform: this.fb.group({
        clientId: [''],
        secret: [''],
        vehicleInspectionFormId: ['']
      }),
      reserved: this.fb.group({
        time: [''],
      }),
      taxInformation: this.fb.group({
        name: [''],
        npi: [''],
        taxId: [''],
        taxonomy: [''],
        email: ['', [Validators.email]],
        imageUrl:['']
      }),
      timeZone:[timeZone],

      address: this.fb.group({
        name: [''],
        coords: [[]],
        city: [''],
        state: [''],
        zipCode: ['']
      },{ validators: addressValidator() }),

      focalPersonInformation: this.fb.group({
        name: [''],
        contactNumber: ['',[phoneNumberLengthValidator]]
      },{ validators: allowOnlyNumbersValidator('contactNumber')})
    })
    //  this.getConfigurationbyId();

  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
        this.getAllGlobalConfig();
        this.getCompanyList();
      }
    })
  }

  // getConfigurationbyId() {
  //   this.configService.getConfigByCompanyWise(this.companyId)
  //     .pipe(untilDestroyed(this))
  //     .subscribe((data: any) => {
  //       if (data) {
  //         this.configId = data._id
  //         this.companyWiseConfiguration = data
  //         this.globalConfigForm.patchValue({
  //           ...data
  //         });
  //       }
  //     });
  //   }


  getAllGlobalConfig(){
    this.configService.getAllGlobalConfig().subscribe((data:any)=>{
      if(data && data.results){
        const config = data.results[0];
        this.configId = config.id;
        let reservedTime = null;

        if (config?.reserved?.time && /^\d{2}:\d{2}$/.test(config.reserved.time)) {
          const [hours, minutes] = config.reserved.time.split(":").map(Number);

          reservedTime = moment()
            .startOf("day")
            .hour(hours)
            .minute(minutes)
            .second(0)
            .millisecond(0)
            .toDate();
        }

        this.globalConfigForm.patchValue({
          ...config,
          reserved: {
            ...config.reserved,
            time: reservedTime
          }
        });
        this.imageUrl = config?.taxInformation?.imageUrl;
        if (this.globalConfigForm.value.address) {
          this.globalConfigForm.patchValue({
            address: {
              ...this.globalConfigForm.value.address,
              coords: [34.53535, 56.56565]
            }
          });
        }
      }
    })
  }

  getCompanyList() {
    this.credentialService.getPicker({ isActive: true, isApproved: true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.companyList = data.results || [];
      }
    })
  }
   
    onSave() {
      this.submitted = true;
      if (this.globalConfigForm.invalid) return;
  
      const payload = this.globalConfigForm.value;
      if (payload?.address) {
        delete payload.address.coords;
      }
      if (payload.reserved?.time) {
        payload.reserved.time = moment(payload.reserved.time)
          .format('HH:mm');
      }
      this.configService.saveGlobalConfig(this.configId, payload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: any) => {
            if (data) {
              // this.router.navigateByUrl('/configurations/global');
            }
          },
          error: (err: any) => {
            sweetAlert("Error", err, "error", "OK");
          },
          complete() {
              sweetAlert("Success", "Configuration Saved successfully!", "success", "OK");
          },
        });
    }


  toggleAutoInvoice(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.globalConfigForm.patchValue({
      quickbooks:{
        isAutoInvoice: isChecked
      }
    });
  }

  toggleAutoAccepted(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.globalConfigForm.patchValue({
      quickbooks:{
        isAutoAccepted: isChecked,
        ...(!isChecked && { isAutoBill: false })
      }
    });
  }

  toggleAutoBill(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked && !!this.globalConfigForm.get('quickbooks.isAutoAccepted')?.value;
    this.globalConfigForm.patchValue({
      quickbooks:{
        isAutoBill: isChecked
      }
    });
  }

  processFile(imageInput: any) {
    const file = imageInput.files?.[0];
    if (!validateFileSize(file)) {
      return;
    }
    imageProcessing(imageInput).pipe(untilDestroyed(this)).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          console.error('Invalid file selected.');
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile, urls.COMPANIES).pipe(untilDestroyed(this)).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.taxInformation.get('imageUrl')?.setValue(uploadResult.fileUrl);
              this.imageUrl = uploadResult.fileUrl
            }
          },
          error: (uploadError) => {
            console.error('Error uploading image:', uploadError);
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  get form() {
    return this.globalConfigForm.controls;
  }

  get taxInformation() {
    return this.globalConfigForm.get('taxInformation') as FormGroup;
  }

  get addressForm() {
    return this.globalConfigForm.get('address') as FormGroup;
  }

  get focalPersonInformation() {
    return this.globalConfigForm.get('focalPersonInformation') as FormGroup;
  }

  get reserved(): FormGroup {
    return this.globalConfigForm.get('reserved') as FormGroup;
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }
}
